export const downloadFile = (blob: Blob, filename: string, fileFormat: string, file?: any, responseFileName?: string) => {
    let format = fileFormat;
    let blobData = blob;
    let fileData = file;

    try {
        if (file) {
            let signature: any = file.slice(0, 6);
            if (signature instanceof Uint8Array) {
                // @ts-ignore
                signature = String.fromCharCode.apply(null, new Uint8Array(signature));
            }

            if( format === "xls" ) {}
            else if( format === "json" ) {}
            else if( signature === "{\\rtf1" ) format = "rtf";
            else if( signature === "%PDF-1" ) format = "pdf";
            else if( signature.startsWith("PK") ) format = "docx";
            else if( signature.startsWith("zip") ) {
                format = "zip"; // zip дописали в backend-е, чтобы отличить от docx
                fileData = fileData.slice(3); // теперь нужно отрезать zip
            }
            else if( signature.startsWith("7z") ) format = "7z";
            else if( signature === "<?xml " ) format = "xml";
            //else if( signature.charCodeAt(0) === 0xEF ) format = "xml"; // будем считать, что это XML с BOM UTF-8
            else if( signature.slice(3) === "<?x" ) format = "xml"; // будем считать, что это XML с BOM UTF-8
            else format = "csv";

            blobData = new Blob([fileData], {type: "application/octet-binary" });
        }
    } catch (e)  {
        console.error(e);
    }

    const fullName = responseFileName ? responseFileName : filename + "." + format;

    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blobData);
    downloadLink.download = fullName;
    downloadLink.click();
    URL.revokeObjectURL(downloadLink.href);
    downloadLink.remove();
}
